import { render } from "./ViewAll.vue?vue&type=template&id=570f2172&scoped=true"
import script from "./ViewAll.vue?vue&type=script&lang=js"
export * from "./ViewAll.vue?vue&type=script&lang=js"

import "./ViewAll.vue?vue&type=style&index=0&id=570f2172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570f2172"],['__file',"src/views/ViewAll.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "570f2172"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('570f2172', __exports__)) {
    api.reload('570f2172', __exports__)
  }
  
  module.hot.accept("./ViewAll.vue?vue&type=template&id=570f2172&scoped=true", () => {
    api.rerender('570f2172', render)
  })

}


export default __exports__